import { Teaser as t } from '@xprog/prensa/types'

export const addRelativeWidthToTeaser = (teaser, value): t.TeaserProps => {
  return {
    ...teaser,
    css: {
      ...teaser?.css,
      '@lg': {
        ...teaser?.css?.['@lg'],
        width: value
      }
    }
  }
}